import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import MainLayout from './components/Layout/MainLayout';
import Home from './components/Pages/Home';
import Students from './components/Pages/Students';
import Classes from './components/Pages/Classes';
import ClassAssignment from './components/Pages/ClassAssignment';
import Teachers from './components/Pages/Teachers';
import Subjects from './components/Pages/Subjects';
import Instruments from './components/Pages/Instruments';
import Login from './components/Pages/Login';
import { getCurrentAcademicYear } from './services/utils';
import './App.css';

function AppContent() {
  const [currentYear, setCurrentYear] = useState(getCurrentAcademicYear());
  const { isAuthenticated, loading } = useAuth();

  const handleYearChange = (year) => {
    const yearNum = parseInt(year);
    if (yearNum >= 2025 && yearNum <= 2035) {
      setCurrentYear(yearNum);
    }
  };

  // Verificando sesión con el servidor al cargar
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated()) {
    return (
      <div className="App min-h-screen bg-gray-50">
        <Toaster position="top-right" />
        <Login onSuccess={() => {}} />
      </div>
    );
  }

  return (
    <div className="App min-h-screen bg-gray-50">
      <Toaster position="top-right" />
      <MainLayout currentYear={currentYear} onYearChange={handleYearChange}>
        <Routes>
          <Route path="/" element={<Home currentYear={currentYear} />} />
          <Route path="/alumnos" element={<Students currentYear={currentYear} />} />
          <Route path="/clases" element={<Classes currentYear={currentYear} />} />
          <Route path="/asignacion" element={<ClassAssignment currentYear={currentYear} />} />
          <Route path="/profesores" element={<Teachers />} />
          <Route path="/asignaturas" element={<Subjects />} />
          <Route path="/instrumentos" element={<Instruments />} />
        </Routes>
      </MainLayout>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
